import React, {useEffect, useState} from 'react';
import {useStores} from "../../../../stores/Context";
import axios from "axios";
import BtnPlus from "../../../../boiteAOutils/BtnPlus";


const BibliothequeImagesModule = () => {

    const {bibliothequeImagesStore, widgetStore} = useStores();
    const [images, setImages] = useState('');
    const [loadImage, setLoadImage] = useState(true);


    useEffect(() => {
        if (loadImage){
            axios.get(process.env.REACT_APP_API_URL + '/api/bibliothequeImages/getAllImagesByIdTotem/' + widgetStore.idTotem).then((res) => {
                setImages(res.data)
                setLoadImage(false);
            });
        }
    }, [loadImage]);

    return (
        <div>
            <div className={"moduleImageContent"}>
                <div className={"consigneModifyHeader"}>

                    <div onClick={() => bibliothequeImagesStore.handleCloseModuleImage()} style={{cursor: "pointer", rotate: "180deg"}}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.2363 7.16016L14.8809 12.0004L10.2363 16.8406" stroke="#70787B"
                                  strokeWidth="2"/>
                            <line x1="14.6973" y1="12.3281" x2="2.43556" y2="12.3281" stroke="#70787B"
                                  strokeWidth="2"/>
                            <line x1="19.0469" y1="5.39844" x2="19.0469" y2="18.6044" stroke="#70787B"
                                  strokeWidth="2"/>
                        </svg>
                    </div>

                    <h3 className={"consigneModifyTitleH3"}>Mes images</h3>
                </div>

                <div className={"consigneModifyHeaderSeparateur"}></div>
                <div className={"consigneModifyBodyContent"}>

                    <div className={`flex-1 grid`} style={{ gridTemplateColumns: `repeat(3, 1fr)`, gap: "4px" }}>
                        {images && images.map((photo, index) => (
                            <div style={{position: 'relative'}}>
                                <BtnPlus onClick={() => bibliothequeImagesStore.onSelectedImageModule(photo.name)}
                                         style={{position: "absolute", top: '-1em', right: '-0.5em', zIndex: 1000}}
                                />
                                <img src={process.env.REACT_APP_API_URL+'/'+photo.url}
                                     alt={`Photo ${index + 1}`}
                                     style={{borderRadius: '12px'}}

                                />
                            </div>

                        ))
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BibliothequeImagesModule;